
export function updateCountry(countryList = []) {
  return (value) => {
    const user = {
      country : value
    };
    const otherCountry = countryList.find(c => c.subElement === 'Other');

    if (otherCountry && user.country === otherCountry.id) {
      user.state = null;
    }
    else {
      user.countryOther = null;
    }

    return user;
  };
}



// WEBPACK FOOTER //
// ./shared/lib/users/updates.js